import { Button, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import ReactCanvasConfetti from 'react-canvas-confetti'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { routes } from '../../../consts'
import $t from '../../../i18n'
import SuccessImageV2 from '../../../resources/SuccessPaymentV2.svg'
import './ExternalPaymentSuccessPage.css'
import { useLocation } from 'react-router'
import useQuery from '../../../hooks/useQuery'
import { event, eventTypes } from '../../../consts/eventConsts'
import { isLoggedIn } from '../../../utils/fetchUtils'

const ExternalPaymentSuccessPage = () => {
  const dispatch = useDispatch()
  const selectedPlan = useSelector(state => state.payment.selectedPlan)
  const isCompletePackage = useSelector(
    state => state.payment?.selectedPlan?.is_complete_package
  )
  const [displayConfetti, setDisplayConfetti] = useState(false)
  const [renderSuccessPage, setRenderSuccesPage] = useState(false)
  const isLoggedInUser = useSelector(state => state.auth.isLoggedIn)
  const location = useLocation()
  const query = useQuery()

  useEffect(() => {
    let id = query.get('id')
    if (id !== undefined) {
      // dispatch(Actions.createAction(Actions.PAYMENT_PLAN_REQUESTED, { id }))
      dispatch(Actions.createAction(Actions.NEW_USER_PPF_TOGGLE_MODAL))
      dispatch(Actions.createAction(Actions.REVOKE_PPF_ORDER))
    }
  }, [location])

  useEffect(() => {
    if (!isLoggedInUser) {
      setDisplayConfetti(true)
    }
    setTimeout(() => {
      setRenderSuccesPage(true)
    }, 1000)
  }, [selectedPlan])
  const handleDownload = () => {
    window.open(`https://antidotehealth.onelink.me/IQ2R/bts2vcaa`, '_blank')
    if (selectedPlan?.is_ppf) {
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_download',
          data: { planId: selectedPlan?.id },
        })
      )
    }
    if (selectedPlan?.is_gifting) {
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'gifting_success_download',
          data: { planId: selectedPlan?.id },
        })
      )
    }
  }
  const handleSignIn = () => {
    if (isLoggedIn()) {
      dispatch(Actions.createAction(Actions.PPF_USER_LOGIN))
      dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_login',
          data: { planId: selectedPlan?.id },
        })
      )
    } else {
      dispatch(
        Actions.createAction(Actions.NAVIGATED_TO, routes.ONE_TIME_LOGIN)
      )
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_login',
          data: { planId: selectedPlan?.id },
        })
      )
    }
  }
  const handlePrimarySignIn = () => {
    if (isLoggedIn()) {
      dispatch(Actions.createAction(Actions.PPF_USER_LOGIN))
      dispatch(
        Actions.createAction(Actions.ENABLE_PRIMARY_CARE_BOT_FROM_SUCCESS)
      )
      dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_login',
          data: { planId: selectedPlan?.id },
        })
      )
    } else {
      dispatch(
        Actions.createAction(Actions.ENABLE_PRIMARY_CARE_BOT_FROM_SUCCESS)
      )
      dispatch(
        Actions.createAction(Actions.NAVIGATED_TO, routes.ONE_TIME_LOGIN)
      )
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_login',
          data: { planId: selectedPlan?.id },
        })
      )
    }
  }
  const handleHtnSignIn = () => {
    if (isLoggedIn()) {
      dispatch(Actions.createAction(Actions.PPF_USER_LOGIN))
      dispatch(
        Actions.createAction(Actions.ENABLE_HYPERTENSION_BOT_FROM_SUCCESS)
      )
      dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_login',
          data: { planId: selectedPlan?.id },
        })
      )
    } else {
      dispatch(
        Actions.createAction(Actions.ENABLE_HYPERTENSION_BOT_FROM_SUCCESS)
      )
      dispatch(
        Actions.createAction(Actions.NAVIGATED_TO, routes.ONE_TIME_LOGIN)
      )
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_login',
          data: { planId: selectedPlan?.id },
        })
      )
    }
  }
  const handleDmSignIn = () => {
    if (isLoggedIn()) {
      dispatch(Actions.createAction(Actions.PPF_USER_LOGIN))
      dispatch(Actions.createAction(Actions.ENABLE_DIABETES_BOT_FROM_SUCCESS))
      dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_login',
          data: { planId: selectedPlan?.id },
        })
      )
    } else {
      dispatch(Actions.createAction(Actions.ENABLE_DIABETES_BOT_FROM_SUCCESS))
      dispatch(
        Actions.createAction(Actions.NAVIGATED_TO, routes.ONE_TIME_LOGIN)
      )
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_login',
          data: { planId: selectedPlan?.id },
        })
      )
    }
  }
  if (isLoggedInUser) {
    dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
    return null
  }

  if (renderSuccessPage) {
    if (selectedPlan?.is_gifting) {
      return (
        <div>
          <div className="payment-success-container overwrite-payment-success-container">
            <div className="payment-success center">
              <div className="success-page-image">
                <img src={SuccessImageV2} alt="" />
              </div>
              <div className="body">
                <div className="main-title overwrite-main-title">
                  {$t('pages.success.title')}!
                </div>
                <div className="sub-title">
                  <div className="payment-success-sub">
                    {$t('pages.successV2.purchaseComplete')} <br />
                  </div>
                  <br />
                  <div className="payment-success-confirmation-text">
                    <p>{$t('pages.successV2.giftingConfirmationEmail')}</p>
                  </div>
                  <div className="payment-success-confirmation-text">
                    <p>{$t('pages.successV2.giftingExplanation')}</p>
                  </div>
                </div>
              </div>
              <ReactCanvasConfetti
                style={{
                  position: 'fixed',
                  width: '100%',
                  height: '100%',
                  zIndex: -1,
                }}
                colors={['#fb6f44', '#004C74']}
                fire={displayConfetti}
                className="canvas"
              />
            </div>

            <div className="footer">
              <span className="or-sign-in">
                {$t('pages.successV2.giftingTryYourself')}
              </span>
              <Button
                type="primary"
                onClick={() => {
                  dispatch(
                    Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
                      eventName: 'gifting_success_login',
                      data: { planId: selectedPlan?.id },
                    })
                  )
                  window.location.href = selectedPlan?.plans_page
                }}
                className="continue-button"
              >
                {$t('pages.successV2.packagesAndPricing')}
              </Button>

              <span className="or-sign-in">
                {$t('pages.successV2.or')}
                <span className="continue-to-sign-in" onClick={handleDownload}>
                  {' '}
                  {$t('pages.successV2.download')}
                </span>
              </span>
            </div>
          </div>
        </div>
      )
    } else if (isCompletePackage) {
      return (
        <div>
          <div className="payment-success-container complete-package-container">
            <div className="payment-success center">
              <div className="body">
                <div className="main-title complete-package-title">
                  {$t('pages.success.title')}!
                </div>
                <div className="sub-title">
                  <div className="payment-success-sub complete-package-subtitle">
                    {$t('pages.successV2.purchaseComplete')}
                  </div>
                  <br />
                  <div className="payment-success-confirmation-text">
                    <p>{$t('pages.successV2.confirmationMail')}</p>
                  </div>
                  <div className="order-details-confirmation-box complete-package-box">
                    <h5>{$t('pages.successV2.purchaseDetails')}</h5>
                    <div className="divider"></div>
                    <div className="order-details-payment-success ">
                      <div className="payment-success-column">
                        <span className="order-details-heading">
                          {' '}
                          {$t('pages.successV2.productPurchased')}
                        </span>
                        <br />
                        <span className="order-details-item">
                          {selectedPlan?.title}
                        </span>
                      </div>
                      <div className="payment-success-column">
                        <span className="order-details-heading">
                          {' '}
                          {$t('pages.successV2.purchasePrice')}
                        </span>
                        <br />
                        <span className="order-details-item">
                          ${selectedPlan?.price}{' '}
                          {selectedPlan?.show_terms && 'per month'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="payment-success-confirmation-text complete-care-package-select-bot-text">
                    <p>
                      {$t('pages.successV2.pickBot')}
                      <br />
                      {$t('pages.successV2.unsure')}
                    </p>
                  </div>
                </div>
              </div>
              <ReactCanvasConfetti
                style={{
                  position: 'fixed',
                  width: '100%',
                  height: '100%',
                  zIndex: -1,
                }}
                colors={['#fb6f44', '#004C74']}
                fire={displayConfetti}
                className="canvas"
              />
            </div>

            <div className="footer">
              <div className="complete-care-footer-actions">
                <Button
                  type="primary"
                  onClick={handlePrimarySignIn}
                  className="continue-button complete-care-footer-button"
                >
                  {$t('clinicNames.primary')}
                </Button>
                <Button
                  type="primary"
                  onClick={handleHtnSignIn}
                  className="continue-button complete-care-footer-button"
                >
                  {$t('clinicNames.hypertension')}
                </Button>
                <Button
                  type="primary"
                  onClick={handleDmSignIn}
                  className="continue-button complete-care-footer-button"
                >
                  {$t('clinicNames.diabetes')}
                </Button>
              </div>

              <span className="or-sign-in">
                {$t('pages.successV2.or')}
                <span className="continue-to-sign-in" onClick={handleDownload}>
                  {' '}
                  {$t('pages.successV2.download')}
                </span>
              </span>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div>
        <div className="payment-success-container overwrite-payment-success-container">
          <div className="payment-success center">
            <div className="success-page-image">
              <img src={SuccessImageV2} alt="" />
            </div>
            <div className="body">
              <div className="main-title overwrite-main-title">
                {$t('pages.success.title')}!
              </div>
              <div className="sub-title">
                <div className="payment-success-sub">
                  {$t('pages.successV2.purchaseComplete')} <br />
                  {$t('pages.successV2.please')}
                  <span
                    className="continue-to-sign-in"
                    onClick={() => handleSignIn()}
                  >
                    {' '}
                    {$t('pages.successV2.signIn')}
                  </span>{' '}
                  {$t('pages.successV2.toGetStarted')}
                </div>
                <br />
                <div className="payment-success-confirmation-text">
                  <p>{$t('pages.successV2.confirmationMail')}</p>
                </div>
                <div className="order-details-confirmation-box">
                  <h5>{$t('pages.successV2.purchaseDetails')}</h5>
                  <div className="divider"></div>
                  <div className="order-details-payment-success">
                    <div className="payment-success-column">
                      <span className="order-details-heading">
                        {' '}
                        {$t('pages.successV2.productPurchased')}
                      </span>
                      <br />
                      <span className="order-details-item">
                        {selectedPlan?.title}
                      </span>
                    </div>
                    <div className="payment-success-column">
                      <span className="order-details-heading">
                        {' '}
                        {$t('pages.successV2.purchasePrice')}
                      </span>
                      <br />
                      <span className="order-details-item">
                        ${selectedPlan?.price}{' '}
                        {selectedPlan?.show_terms && 'per month'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ReactCanvasConfetti
              style={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                zIndex: -1,
              }}
              colors={['#fb6f44', '#004C74']}
              fire={displayConfetti}
              className="canvas"
            />
          </div>

          <div className="footer">
            <Button
              type="primary"
              onClick={() => handleSignIn()}
              className="continue-button"
            >
              {$t('pages.successV2.signIn')}
            </Button>

            <span className="or-sign-in">
              {$t('pages.successV2.or')}
              <span className="continue-to-sign-in" onClick={handleDownload}>
                {' '}
                {$t('pages.successV2.download')}
              </span>
            </span>
          </div>
        </div>
      </div>
    )
  } else {
    return <Spin size="large"></Spin>
  }
}

export default ExternalPaymentSuccessPage
